import { useContext } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

export default function OverlayLoader(props) {

  const appContext = useContext(AppContext);

  

  return (
    <div 
      className="OverlayLoader"
      style={{
        display: (appContext.showOverlayLoader) ? 'flex' : 'none',
      }}
    >
      {getInlineLoader({
        variant: "overlay",
        centered: false,
        text: "Working on it",
        label: "Working on it",
      })}
    </div>
  )
}
